/** Durable skip is a timestamp, not activation. */
export function onboardingSkipProfilePatch(at = new Date()) {
  return {
    onboardingSkippedAt: at,
    hasCompletedOnboarding: false as const,
  };
}

export function onboardingSkipDatabasePatch(at = new Date()) {
  return {
    onboarding_skipped_at: at.toISOString(),
  };
}
